import RegisterEmitentView from './RegisterEmitentView'

export default RegisterEmitentView
